import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateHostedGamePlaceholderPlayerDto, CreatePlaceholderPlayerPathParams } from '@core-http';

export class AddPlayerCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  addPlayer(gameId: string, displayName: string): Observable<void> {
    const pathParams: CreatePlaceholderPlayerPathParams = { hostedGameId: gameId };
    const payload: CreateHostedGamePlaceholderPlayerDto = { displayName };

    return this.hostedGamesService.addPlayer(pathParams, payload);
  }
}
